import './App.css';
import React from 'react';
import SchulteTable from './Pages/SchulteTable/SchulteTable'
import SchulteHome from './Pages/SchulteTable/SchulteHome';
import SchulteMedium from './Pages/SchulteTable/SchulteMedium';
import SchulteHard from './Pages/SchulteTable/SchulteHard';
import Home from './Pages/Home/Home'
import About from './Pages/About';
import Register from './Pages/Register'
import Login from './Pages/Login/Login'
import Contact from './Pages/Contact'
import RememberIt from './Pages/RememberIt/RememberIt'
import Statistics from './Pages/Statistics/Statistics'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import MirrorImage from './Pages/MirrorImage/MirrorImage';
import Tutorial from './Pages/SchulteTable/Tutorial';


class App extends React.Component{
    render() {
        return (
                <Router>
                    <Switch>
                        <Route path="/" exact component={Home} />
                        <Route path="/schulteHome" exact component={SchulteHome} />
                        <Route path="/schulteTable" component={SchulteTable} />
                        <Route path="/schulteTableRestart" exact component={About} />
                        <Route path="/register" component={Register} />
                        <Route path="/login" component={Login} />
                        <Route path="/about" component={About} />
                        <Route path="/contact" component={Contact} />
                        <Route path="/mirrorImage" component={MirrorImage} />
                        <Route path="/rememberIt" component={RememberIt} />
                        <Route path="/statistics" component={Statistics} />
                        <Route path="/schulteHome" exact component={Home} />
                        <Route path="/schulteHome/easy" component={SchulteTable} />
                        <Route path="/schulteHome/medium" exact component={SchulteMedium} />
                        <Route path="/schulteHome/hard" component={SchulteHard} />
                        <Route path="/schulteHome/tutorial" component={Tutorial} />
                    </Switch>
                </Router>
        )
    }
}

export default App;
